export const SET_COMMENTS = 'SET_COMMENTS';



// WEBPACK FOOTER //
// ./src/actions/types.js